import de_DE from "wording/builtInWording/de_DE.json";
import en from "wording/builtInWording/en.json";
import en_CA from "wording/builtInWording/en_CA.json";
import en_US from "wording/builtInWording/en_US.json";
import es_AR from "wording/builtInWording/es_AR.json";
import es_CL from "wording/builtInWording/es_CL.json";
import es_ES from "wording/builtInWording/es_ES.json";
import es_UY from "wording/builtInWording/es_UY.json";
import fr_CA from "wording/builtInWording/fr_CA.json";
import fr_FR from "wording/builtInWording/fr_FR.json";
import it_IT from "wording/builtInWording/it_IT.json";
import pl_PL from "wording/builtInWording/pl_PL.json";
import hu_HU from "wording/builtInWording/hu_HU.json";
import pt_BR from "wording/builtInWording/pt_BR.json";
import de_CH from "wording/builtInWording/de_CH.json";
import fr_CH from "wording/builtInWording/fr_CH.json";
import it_CH from "wording/builtInWording/it_CH.json";

export const builtInWording = {
	"de-DE": de_DE,
	"en-CA": en_CA,
	"en-US": en_US,
	en,
	"es-AR": es_AR,
	"es-CL": es_CL,
	"es-ES": es_ES,
	"es-UY": es_UY,
	"fr-CA": fr_CA,
	"fr-FR": fr_FR,
	"it-IT": it_IT,
	"pl-PL": pl_PL,
	"hu-HU": hu_HU,
	"pt-BR": pt_BR,
	"de-CH": de_CH,
	"fr-CH": fr_CH,
	"it-CH": it_CH,
};
